import script from './component-lib.esm170.js';
import normalizeComponent from '../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    attrs: {
      "viewBox": "0 0 32 21.22"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'embed'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M31,21.22H29.5v-2H30v-.5h2v1.5A1,1,0,0,1,31,21.22Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M28.57,21.22H25.78v-2h2.79Zm-3.73,0H22.05v-2h2.79Zm-3.72,0H18.33v-2h2.79Zm-3.72,0H14.6v-2h2.8Zm-3.73,0H10.88v-2h2.79Zm-3.72,0H7.16v-2H10Zm-3.73,0H3.43v-2H6.22Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.5,21.22H1a1,1,0,0,1-1-1v-1.5H2v.5h.5Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2,17.77H0V14.9H2ZM2,14H0V11.09H2Zm0-3.82H0V7.27H2ZM2,6.32H0V3.45H2Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2,2.5H0V1A1,1,0,0,1,1,0H2.5V2H2Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M28.57,2H25.78V0h2.79ZM24.85,2h-2.8V0h2.8ZM21.12,2H18.33V0h2.79ZM17.4,2H14.6V0h2.8ZM13.67,2H10.88V0h2.79ZM10,2H7.16V0H10ZM6.22,2H3.43V0H6.22Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M32,2.5H30V2h-.5V0H31a1,1,0,0,1,1,1Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M32,17.77H30V14.9h2ZM32,14H30V11.09h2Zm0-3.82H30V7.27h2Zm0-3.81H30V3.45h2Z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var EmbedOutlineIcon = __vue_component__;
export { EmbedOutlineIcon as default };